import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import MedicationResources from "../MedicationResources";
import { therapies } from "../data/therapyData";
import Disclaimer from "../components/Disclaimer";
import TopBar from "../components/TopBar"; // ← reusable header (breadcrumb + avatar/login + white nav + modals)

const Therapies = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const therapyFromSearch = queryParams.get("treatment");

  const defaultTherapy = therapyFromSearch || Object.keys(therapies)[0];
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const [selectedTherapy, setSelectedTherapy] = useState(defaultTherapy);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [showTreatmentSelector, setShowTreatmentSelector] = useState(true);

  useEffect(() => {
    if (therapyFromSearch && therapies[therapyFromSearch]) {
      setSelectedTherapy(therapyFromSearch);
    }
  }, [therapyFromSearch]);

  if (!therapies[selectedTherapy]) {
    return <h2>Error: Therapy not found.</h2>;
  }

  const { name, description, cost, insuranceCoverage, resources } =
    therapies[selectedTherapy];

  const handleViewSummary = (summary) => {
    setSelectedSummary(summary);
  };

  const handleCloseSummary = () => {
    setSelectedSummary(null);
  };

  return (
    <div className="page-container">
      {/* Reusable header (breadcrumb + account dropdown + white nav + modals) */}
      <TopBar breadcrumb={`Therapies > ${therapies[selectedTherapy]?.name}`} />

      <div className="medications-container">
        {isMobile && showTreatmentSelector && (
          <div className="treatment-selector-overlay">
            <div className="overlay-header">
              <button
                className="back-button"
                onClick={() => setShowTreatmentSelector(false)}
              >
                ← Back
              </button>
              <h2>Medical Therapies</h2>
            </div>
            <div className="overlay-treatments">
              {Object.keys(therapies).map((item) => (
                <div
                  key={item}
                  className={`category-card ${
                    selectedTherapy === item ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedTherapy(item);
                    navigate(`/therapies?treatment=${encodeURIComponent(item)}`);
                    setShowTreatmentSelector(false);
                  }}
                >
                  <h3>{therapies[item].name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {isMobile && !showTreatmentSelector && (
          <button
            className="select-treatment-button"
            onClick={() => setShowTreatmentSelector(true)}
          >
            Select a Treatment
          </button>
        )}

        <div className="medication-layout">
          {/* Sidebar */}
          <div className={`sidebar ${isMobile && showSidebar ? "open" : ""}`}>
            <h2 className="sidebar-title">Therapies</h2>
            <p className="sidebar-description">
              Explore different therapy treatments for chronic pain.
            </p>
            <div className="sidebar-blocks">
              {Object.keys(therapies).map((therapy) => (
                <div
                  key={therapy}
                  className={`category-card ${
                    selectedTherapy === therapy ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedTherapy(therapy);
                    navigate(`/therapies?treatment=${encodeURIComponent(therapy)}`);
                    if (isMobile) setShowSidebar(false);
                  }}
                >
                  <h3>{therapies[therapy].name}</h3>
                </div>
              ))}
            </div>
          </div>

          {/* Two-Box Layout */}
          <div className="main-content">
            <div className="medication-info-box">
              <h2 className="medication-title">{name}</h2>
              <p className="medication-description">{description}</p>
              {cost && (
                <p className="medication-info">
                  <strong>Cost:</strong> {cost}
                </p>
              )}
              {insuranceCoverage && (
                <p className="medication-info">
                  <strong>Insurance Coverage:</strong> {insuranceCoverage}
                </p>
              )}
            </div>

            <div className="research-box">
              <h3 className="resources-title">Research on Therapy Outcomes</h3>
              <MedicationResources
                resources={resources}
                onViewSummary={handleViewSummary}
              />
            </div>
          </div>
        </div>

        {selectedSummary && (
          <div className="summary-modal">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseSummary}>
                ×
              </button>
              <h3 style={{ textAlign: "left" }}>Summary</h3>
              <div className="summary-scroll">
                <p className="sidebar-description-left">{selectedSummary}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Disclaimer />
    </div>
  );
};

export default Therapies;
